"use client"

import type { ReactNode } from "react"

import { Button } from "./Button"
import { Dialog } from "./Dialog"

export type ConfirmDialogProps = {
  open: boolean
  title: ReactNode
  description?: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  variant?: "danger" | "primary"
  busy?: boolean
  onConfirm: () => void | Promise<void>
  onClose: () => void
}

// Confirmação de ação destrutiva/irreversível. `description` carrega o texto de
// impacto (ex.: "perde o histórico"). Botão de confirmação em vermelho por
// padrão (danger).
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  variant = "danger",
  busy = false,
  onConfirm,
  onClose,
}: ConfirmDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      description={description}
      footer={
        <>
          <Button type="button" variant="ghost" size="sm" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant={variant}
            size="sm"
            loading={busy}
            onClick={() => void onConfirm()}
          >
            {confirmLabel}
          </Button>
        </>
      }
    />
  )
}
